import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Sofía', 'Camila', 'Martina', 'Lucía', 'Valentina', 'Florencia', 'Agustina', 'Catalina', 'Julieta', 'Micaela', 'Romina', 'Daniela', 'Carla', 'Belén', 'Antonella'];
const CITIES = ['Buenos Aires', 'Rosario', 'Córdoba', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'Santa Fe', 'Resistencia'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    const initialTimer = setTimeout(showPopup, 4000);
    const interval = setInterval(() => {
      showPopup();
    }, 18000); // Trigger every 18 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-125">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-xl border border-primary-dark p-4 flex items-center gap-4 max-w-xs cursor-default" data-id="element-126">
          <div className="bg-green-100 p-2 rounded-full text-green-600 flex-shrink-0" data-id="element-127">
            <CheckCircle2 size={24} data-id="element-128" />
          </div>
          <div data-id="element-129">
            <p className="text-sm font-bold text-text leading-tight" data-id="element-130">
              {currentData.name} de {currentData.city}
            </p>
            <p className="text-xs text-text-light mt-1" data-id="element-131">
              Acaba de comprar el ebook
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}